export const emptyFilters = {
  search: '',
  categories: [],
  subtypes: [],
  rarity: [],
  modsRarity: [],
  damageType: [],
  various: [],
  tokens: [],
  sets: []
}

export function cleanFilters (state) {
  Object.entries(emptyFilters)
    .forEach(([k, v]) => {
      state[k] = v
    })
}



// WEBPACK FOOTER //
// ./src/store/destiny/filters/tools.js